var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15677 1.89H12.4779L13.75 0H1.27207L0 1.89H2.16509C4.35716 1.89 6.3806 2.05667 7.19066 3.87H1.28152L0.0101172 5.75933H7.42942C7.42942 7.11933 6.28955 9.20267 2.51919 9.20267H0.698089V10.9693L8.00881 20H11.2639L3.69954 10.6667C6.81227 10.5 9.73346 8.77933 10.1543 5.76267H12.4779L13.75 3.87333H10.1213C9.9843 3.13909 9.65131 2.45437 9.15677 1.89Z",
    fill: "#1A7A42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/Rupee.cdab7582581e6f83a7fc56e16cce55c1.svg";
export { ForwardRef as ReactComponent };